import React from 'react'
import Cta from 'core/styles/Cta'
import Link from 'next/link'
import Grid, { Cell } from 'core/styles/Grid'
import { Container } from 'core/styles/Container'
import { MainCard } from 'core/components/Card'
import styled from 'styled-components'
import { breakpoint } from '../layout/styles'

const FeaturedContent = ({ content }: any) =>
  <Container style={{ margin: '0 auto 48px' }}>
    <FeaturedCard>
      <FeaturedGrid style={{ width: '100%' }}>
        <FeaturedContentContainer md={2}>
          <div>
            <h2 style={{ fontSize: '26px', lineHeight: 1.3 }}>{content.title}</h2>
            <p>{content.description}</p>
            <Link href={content.cta.href} passHref>
              <Cta href="" forceLight={true} style={{ display: 'inline-block' }}>{content.cta.title}</Cta>
            </Link>
          </div>
        </FeaturedContentContainer>
        <FeaturedImage md={10} style={{
          background: `url('${content.background?.url}?width=1440&auto=webp&format=pjpg&quality=75') no-repeat scroll center center`
        }} />
      </FeaturedGrid>
    </FeaturedCard>
  </Container>

export default FeaturedContent

export const FeaturedContentContainer = styled(Cell)`
 flex: 3.5;
 padding: 50px;
 display: flex;
 flex-direction: column;
 justify-content: center;
 h2, p, a {
   color: #000;
 }
 &&& {
  a {
    text-transform: none;
    white-space: normal;
  }
}
`

export const FeaturedImage = styled(Cell)`
  height: 268px;
  background-size: cover !important;
  @media ${breakpoint.desktop} {
    height: 440px;
  }
`
const FeaturedGrid = styled(Grid)`
  flex-direction: column-reverse;
  @media ${breakpoint.desktop} {
    flex-direction: row;
  }

`

export const FeaturedCard = styled(MainCard)`
  &&& {
    margin-top: 0;
    padding: 0;
    width: 100%;
    background: var(--primary);
    color: #fff;
    height: auto;
    @media ${breakpoint.desktop} {
      height: 440px;
      padding-bottom: 0 !important;
    }
  }
`